var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluePenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_454",
    "data-name": "Group 454",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18.001,
    viewBox: "0 0 18 18.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101",
    "data-name": "Rectangle 101",
    width: 18,
    height: 18.001,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M0,296.492c.266-.4.479-.838.717-1.258.408-.721.81-1.445,1.215-2.167.06.056.121.111.179.168l1.334,1.323c0,.011,0,.022,0,.032a.416.416,0,0,1-.065.081c-.763.572-1.529,1.14-2.289,1.717a4.123,4.123,0,0,0-.679.541l-.413-.4v-.035",
    transform: "translate(0 -279.3)",
    fill: "#2b6fb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M8.79,327.849a4.123,4.123,0,0,1,.679-.541c.76-.576,1.526-1.144,2.289-1.717a.416.416,0,0,0,.065-.081c.064.057.129.114.193.172a7.444,7.444,0,0,0,.6.572c-.034.1-.13.111-.2.152q-1.557.87-3.116,1.735c-.039.022-.089.031-.111.078H9.15l-.36-.371",
    transform: "translate(-8.377 -310.22)",
    fill: "#0c61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M123.564,70.61c-.011-.067.048-.089.083-.124q1.624-1.626,3.25-3.251c.07.007.108.067.161.1a.856.856,0,0,0,1.1-.188q1.665-1.662,3.329-3.326c.049-.049.088-.111.159-.134.3.332.619.646.948.95,0,.011,0,.022,0,.032-.04.034-.083.065-.12.1L125.243,72c-.044.044-.1.081-.1.156l-.061-.042c-.5-.507-.994-1.019-1.515-1.506",
    transform: "translate(-117.758 -60.695)",
    fill: "#2b6fb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M45.01,211.053c.52.486,1.015,1,1.515,1.506a.636.636,0,0,1-.053.069l-3.691,3.692c-.037.037-.071.079-.131.077l-1.334-1.324c-.058-.058-.119-.112-.179-.168l3.765-3.767a1.167,1.167,0,0,1,.108-.086",
    transform: "translate(-39.205 -201.139)",
    fill: "#b2d3ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M157.143,92.093c0-.075.059-.111.1-.156l7.23-7.23c.037-.037.08-.068.12-.1.207.2.413.4.621.606.044.043.078.1.154.1-.019.066-.076.1-.121.148l-7.225,7.225a.56.56,0,0,1-.172.147l-.712-.738",
    transform: "translate(-149.761 -80.631)",
    fill: "#0c61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M194.879,26.5c-.071.023-.11.085-.159.134q-1.665,1.663-3.329,3.326a.856.856,0,0,1-1.1.188c-.054-.034-.091-.094-.161-.1a1.044,1.044,0,0,1-.213-.649.735.735,0,0,1,.2-.474q2.08-2.082,4.161-4.162c.134-.134.262-.129.41.017.271.267.539.538.809.806.044.044.08.1.155.1a.3.3,0,0,1,0,.034c-.265.249-.529.5-.769.775",
    transform: "translate(-180.995 -23.509)",
    fill: "#b2d3ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M311.92,2.217a.276.276,0,0,0,0-.034l2.005-2c.251-.25.336-.25.592.005.207.207.415.413.621.622a.278.278,0,0,1,0,.467c-.649.651-1.3,1.3-1.953,1.949-.113.111-.115.179,0,.275a2.213,2.213,0,0,1,.249.248.254.254,0,0,1,.015.365,4.737,4.737,0,0,1-.576.562c-.076,0-.11-.057-.154-.1-.208-.2-.414-.4-.621-.606,0-.011,0-.021,0-.032.213-.208.422-.42.641-.622.1-.1.113-.164,0-.268-.281-.272-.551-.556-.825-.835",
    transform: "translate(-297.267 0)",
    fill: "#4c8ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M77.276,243.146l.712.738c-.038.044-.075.09-.116.131q-1.795,1.8-3.591,3.59c-.044.044-.076.107-.149.114a7.439,7.439,0,0,1-.6-.572c-.063-.058-.128-.115-.193-.172q0-.016,0-.032c.06,0,.094-.04.131-.077l3.691-3.692a.635.635,0,0,0,.053-.069l.061.042",
    transform: "translate(-69.894 -231.684)",
    fill: "#7ab1e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M296.326,47.186c.274.279.544.563.825.835.108.1.1.171,0,.268-.219.2-.428.414-.641.622-.329-.3-.648-.618-.948-.95.24-.275.5-.526.769-.775",
    transform: "translate(-281.673 -44.969)",
    fill: "#7ab1e0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePenIcon);
export default __webpack_public_path__ + "static/media/blue_pen_icon.0a8caa673b912106c980e102b55cb8f3.svg";
export { ForwardRef as ReactComponent };